// extracted by mini-css-extract-plugin
export default {"StockGoods__heading":"StockGoods_StockGoods__heading__3Ne9V","StockGoods__list":"StockGoods_StockGoods__list__2gW87","StockGoods__item":"StockGoods_StockGoods__item__3eIuK"};